import React from "react";

export default function SQL_Editor() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Editor</h1>
      <p>This is the SQL_Editor component generated from the SQL JSON.</p>
    </div>
  );
}
